var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"c-charcounter",class:_vm.remainingChars >= 0 ? 'has-text-success' : 'has-text-danger'},[_vm._v(" "+_vm._s(_vm.remainingChars)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }